import React from 'react';
import { FaHistory, FaRoute, FaTrain, FaWrench, FaRegBookmark } from 'react-icons/fa';
import { Heading, PageTitle } from '../../../components';
import { images } from '../../../constants';
import '../KolejWaskotorowa.css';

// Rozbudowane dane historyczne pobrane wyłącznie z dokumentacji TKW
const timelineData = [
    {
        id: 1,
        phase: '1914 - 1918',
        title: 'Militarne początki i I wojna światowa',
        text: 'W sierpniu 1914 roku wkraczające wojska niemieckie zarekwirowały Cukrownię Gosławice wraz z jej siecią kolei wąskotorowej . Podyktowane potrzebami frontu wojsko błyskawicznie rozbudowywało sieć – 66-kilometrowa linia z Jerzyc do Dąbia Kolskiego powstała w zaledwie 32 dni . Najważniejszą inwestycją była jednak 160-kilometrowa trasa Mątwy – Stryków, do budowy której wykorzystano częściowo koleje cukrownicze . Pierwszy transport wojskowy dotarł do Krośniewic 14 grudnia 1914 roku .',
        image: images.kolej1,
        caption: 'Budowa infrastruktury na potrzeby frontu.'
    },
    {
        id: 2,
        phase: 'Lata 20. i 30. XX w.',
        title: 'Złote lata inwestycji w II RP',
        text: 'Po odzyskaniu niepodległości powołano Zarząd Kolei Dojazdowych w Krośniewicach, który zarządzał siecią o długości 396 km . Okres międzywojenny to czas gigantycznych inwestycji: powstały potężne warsztaty w Krośniewicach i Sompolnie oraz nowe parowozownie . W 1933 roku to właśnie w warsztatach w Krośniewicach zbudowano pierwszy na wąskotorowej sieci PKP pasażerski wagon motorowy .',
        image: images.kolej2,
        caption: 'Rozwój warsztatów i taboru w Krośniewicach.'
    },
    {
        id: 3,
        phase: '1939 - 1945',
        title: 'Mroczny czas okupacji',
        text: 'Działania wojenne w 1939 roku niemal oszczędziły sieć, dzięki czemu Deutsche Reichsbahn szybko wznowiło przewozy, głównie płodów rolnych . W 1940 roku zlikwidowano trakcję spalinową, przebudowując wszystkie trzy wagony motorowe na doczepne i wymontowując z nich silniki . Krośniewickie warsztaty pracowały nieprzerwanie, remontując parowozy ściągane ze wschodu, dopóki w styczniu 1945 roku wycofujący się okupant nie zniszczył urządzeń i nie wywiózł sprzętu .',
        image: images.kolej3,
        caption: 'Naprawa parowozów podczas II wojny światowej.'
    },
    {
        id: 4,
        phase: 'Lata 50. XX w.',
        title: 'Narodziny „Kujawskiego Kolosa”',
        text: 'Sieć przejęła DOKP Łódź i natychmiast przystąpiono do odbudowy . 1 stycznia 1949 roku dołączono koleje powiatowe z Wrześni i Gniezna – od tego momentu wąskim torem można było przejechać z Ozorkowa aż do Gniezna . 12 listopada 1955 roku sieć oficjalnie nazwano Kujawskimi Kolejami Dojazdowymi . Był to złoty wiek – z siecią liczącą blisko 1500 kilometrów, system ten, nazywany „kujawskim kolosem”, był największym w całej Polsce .',
        image: images.kolej4,
        caption: 'Kolej Kujawska u szczytu swojej potęgi.'
    },
    {
        id: 5,
        phase: '1970 - 2001',
        title: 'Zmierzch i podział wąskiego toru',
        text: 'Rozwój komunikacji drogowej i spadek rentowności przyniósł kryzys w latach 70. i 80. . 1 grudnia 1991 roku potężną sieć podzielono na trzy mniejsze, w tym Krośniewicką KD . Od połowy lat 90. sukcesywnie zawieszano ruch pasażerski (m.in. na liniach do Cetty i Ozorkowa) . Ostatecznie, realizując ustawę o restrukturyzacji, PKP zakończyło przewozy pasażerskie w Krośniewicach 8 czerwca 2001 roku .',
        image: images.kolej5,
        caption: 'Ostatnie lata funkcjonowania struktur PKP.'
    },
    {
        id: 6,
        phase: '2002 - 2011',
        title: 'Krótki renesans i upadek',
        text: 'Urząd Gminy w Krośniewicach przejął część majątku, a prywatny operator (SKPL) przywrócił ruch pasażerski na wybranych odcinkach . Niestety umowa została rozwiązana, a 31 marca 2008 roku wagon motorowy MBxd1-204 pojechał z Dąbrowic jako ostatni pociąg pasażerski . W 2011 roku samorząd zwrócił majątek nieruchomy PKP, co otworzyło drogę do powolnej degradacji unikatowej infrastruktury .',
        image: images.kolej6,
        caption: 'Wagon MBxd1-204 na trasie przed zamknięciem ruchu.'
    },
    {
        id: 7,
        phase: 'Od 2019',
        title: 'Przebudzenie – ratunek TKW',
        text: 'Nadzieję na ratunek przyniosło zawiązanie Towarzystwa Kolei Wąskotorowych na początku 2019 roku . Wolontariusze TKW wynajęli i zrewitalizowali część zabytkowej lokomotywowni schodkowej, uzupełniają zmurszałe podkłady i zabezpieczają tabor oraz infrastrukturę przed całkowitym zniszczeniem . Organizują dożynki, dni otwarte i walczą o to, aby przywrócić krośniewickiej stacji dawną świetność oraz ruch turystyczny .',
        image: images.kolej7,
        caption: 'Prace konserwacyjne wolontariuszy TKW.'
    }
];

const KolejWaskotorowaHistoria = () => {
    return (
        <>
            <PageTitle
                title="Kolej Wąskotorowa / Historia"
                page='Historia'
                heading="Ponad sto lat torów"
                subTitle="Od wojskowych transportów, przez epokę Kujawskiego Kolosa, aż po ratunkowe działania dzisiejszych pasjonatów."
            />

            <section className='kw-section kw-history'>
                <div className='kw-container'>
                    
                    {/* Nowy, estetyczny panel wprowadzający (Hero block dla historii) */}
                    <div className='kw-overview-grid' style={{ marginBottom: '4rem' }}>
                        <div className='kw-manifest-box'>
                            <div className='kw-panel-label'>
                                <FaTrain />
                                <span>Potęga Złotego Wieku</span>
                            </div>
                            <h3>Kujawski Kolos</h3>
                            <p>W latach 50. sieć wąskotorowa na Kujawach była fenomenem na skalę krajową.</p>
                            <ul>
                                <li>Rozciągała się na długość prawie 1500 kilometrów.</li>
                                <li>Łączyła regiony pozwalając na przejazd z Ozorkowa aż do Gniezna.</li>
                                <li>Sercem sieci była stacja Krośniewice – największa zachowana stacja kolei wąskotorowej w Polsce.</li>
                            </ul>
                        </div>

                        <div className='kw-copy-box'>
                            <div className='kw-lead-icon'>
                                <FaWrench />
                            </div>
                            <p>
                                W Krośniewicach zachował się unikalny kompleks: lokomotywownia, wagonownia, tokarnia, a nawet odlewnia i kuźnia, tworzące spójny obszar industrialny z nieotynkowanej cegły . 
                                Cała stacja wpisana jest do rejestru zabytków jako przestrzenny układ komunikacyjny .
                            </p>
                        </div>
                    </div>

                    <Heading title="Oś czasu" subTitle="Jak zmieniała się Kujawska Kolej Dojazdowa na przestrzeni dziesięcioleci" sideHeading />

                    <div className='kw-timeline'>
                        {timelineData.map((item, idx) => (
                            <article key={item.id} className={`kw-timeline-item ${idx % 2 === 1 ? 'even' : 'odd'}`}>
                                <div className='kw-timeline-image'>
                                    <img src={item.image} alt={item.title} />
                                    {item.caption && <small className='kw-image-caption'>{item.caption}</small>}
                                </div>

                                <div className='kw-timeline-content'>
                                    <div className='kw-timeline-marker'>
                                        <FaRoute />
                                    </div>
                                    <span>{item.phase}</span>
                                    <h3>{item.title}</h3>
                                    <p>{item.text}</p>
                                </div>
                            </article>
                        ))}
                    </div>

                    <div className='kw-note-box' style={{ marginTop: '4rem' }}>
                        <FaHistory className='kw-note-icon' />
                        <div>
                            <h3>Pamięć wciąż żywa</h3>
                            <p>
                                Jeśli posiadasz własne wspomnienia, fotografie albo informacje związane z tą linią, koniecznie podziel się nimi ze Stowarzyszeniem. Razem możemy zachować to niezwykłe dziedzictwo .
                            </p>
                        </div>
                    </div>
                </div>
            </section>
                        <footer class="site-footer">
                <p>Zdjęcia wykonał Michał Zajfert, rok 1993</p>
            </footer>
        </>
    );
};

export default KolejWaskotorowaHistoria;